import React, { useEffect } from 'react'

interface IProps {

}

/**
 * Emergency "escape hatch" route. Wipes all client-side state (session storage,
 * local storage, and accessible cookies) then forces a full reload onto a fresh
 * login. Useful when a user's cached auth/redux/oidc state gets into a bad shape
 * and normal logout can't recover it. 
 */
const PurgeDataContainer: React.FC<IProps> = () => {

  useEffect(() => {
    try {
      sessionStorage.clear();
      localStorage.clear();

      // Expire every cookie we can read for the current host. HttpOnly cookies
      // are not scriptable and cannot be cleared here, but the ones backing the
      // SPA's client state are. Clear across a few path/domain scopes to be safe.
      const domain = window.location.hostname;
      document.cookie.split(';').forEach((cookie) => {
        const name = cookie.split('=')[0].trim();
        if (!name) return;
        const expire = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';
        document.cookie = `${name}=;${expire};path=/`;
        document.cookie = `${name}=;${expire};path=/;domain=${domain}`;
        document.cookie = `${name}=;${expire};path=/;domain=.${domain}`;
      });
    } catch (err) {
      // storage/cookie access can throw (e.g. blocked cookies); still attempt reload
      console.warn('purge-data: error while clearing client state', err);
    }

    // Point at a fresh login before reloading. Reloading while still on this
    // route would re-run the purge and loop forever, so we swap the hash first.
    // NOTE: `location.reload(true)` (hard reload, bypass cache) is non-standard
    // and not part of the typed API; modern browsers ignore the argument, so we
    // call reload() with no argument.
    window.location.hash = '/login';
    window.location.reload();
  }, []);

  return (
    <section className="access-container">
      <section className="login-container">
        <p>Clearing local data and returning you to a fresh login&hellip;</p>
      </section>
    </section>
  )
}

export default PurgeDataContainer
